import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import Banner from '../components/Banner';
import { Link } from 'react-router-dom';
import { useDataContext } from '../context/DataContext';

const Blogs = () => {
  const { blogs, loading, error, fetchBlogs } = useDataContext();
  useEffect(() => {
    AOS.init({
      duration: 600, // Animation duration
      easing: "ease-in-sine", // Animation easing
    });

    fetchBlogs()
  }, []);


  return (
    <main id="blogs">
      {/* <Banner img="https://images.pexels.com/photos/237289/pexels-photo-237289.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" text="Blogs" /> */}
      {console.log(blogs)}
      <div className="blog-section">
        <div className="container mt-5">
          {loading && <p>Loading blogs...</p>}
          <div className="row g-4">
            {blogs.length > 0 ? (
              blogs.map((blog) =>{ 
                const date = new Date(blog.date_added); 
                const day = date.getDate();
                const month = date.toLocaleString("default", { month: "short" }).toUpperCase();

                return(
                <div key={blog.id} className="col-lg-4 col-md-6">
                  <div className="blog-card">
                    <img src={blog.featured_image || "assets/images/default.jpg"} alt={blog.title} />
                    <div className="blog-wrapper" data-aos="fade-up">

                      <div className="blog-content">
                        <h5>{blog.title}</h5>
                        <p>{blog.short_description || "No summary available."}</p>
                        <Link to={`/blog/${blog.url_title}`} className="view-details">
                          View Details
                        </Link>
                        <div className="line"></div>
                      </div>
                    </div>

                     <div className="date-badge">
                        {day} <br /> {month}
                        {/* {new Date(blog.date).toLocaleString("default", { month: "short" }).toUpperCase()} */}
                      </div>
                  </div>
                </div>
              )})
            ) : (
              !loading && <p>No blogs available.</p>
            )}
            {/* <div className="col-lg-4 col-md-6">
              <div className="blog-card">
                <img src="assets/images/24f0d99b67.jpg" alt="Yacht Image" />
                <div className="blog-wrapper" data-aos="fade-up">
                  <div className="date-badge">28 <br /> JAN</div>
                  <div className="blog-content">
                    <h5>Lorem ipsum dolor sit amet consectetur.</h5>
                    <p>
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Enim pariatur soluta
                      fugiat.
                    </p>
                    <Link to="/blog-inside" className="view-details">View Details</Link>
                    <div className="line"></div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

    </main>
  )
}

export default Blogs